import React from 'react';

const FAQCategory = ({ categories, activeCategory, onSelect }) => {
  return (
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '40px' }}>
      {categories?.map((cat) => {
        const isActive = activeCategory === cat?.id;
        return (
          <button
            key={cat?.id}
            onClick={() => onSelect(cat?.id)}
            style={{
              background: isActive ? 'rgba(255,87,34,0.12)' : 'rgba(255,255,255,0.02)',
              border: isActive ? '1px solid rgba(255,87,34,0.4)' : '1px solid rgba(224,228,232,0.1)',
              borderBottom: isActive ? '2px solid #FF5722' : '2px solid transparent',
              borderRadius: '2px 2px 0 0',
              padding: '10px 20px',
              fontFamily: 'var(--font-heading)',
              fontSize: '12px',
              fontWeight: isActive ? 700 : 600,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: isActive ? '#FF5722' : 'var(--color-muted-foreground)',
              cursor: 'pointer',
              transition: 'all 200ms ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
            onMouseEnter={e => { if (!isActive) { e.currentTarget.style.color = 'var(--color-foreground)'; e.currentTarget.style.borderColor = 'rgba(224,228,232,0.2)'; } }}
            onMouseLeave={e => { if (!isActive) { e.currentTarget.style.color = 'var(--color-muted-foreground)'; e.currentTarget.style.borderColor = 'rgba(224,228,232,0.1)'; } }}
          >
            <span>{cat?.icon}</span>
            <span>{cat?.label}</span>
            <span style={{ background: isActive ? 'rgba(255,87,34,0.2)' : 'rgba(224,228,232,0.08)', borderRadius: '2px', padding: '1px 6px', fontSize: '10px', fontWeight: 700 }}>{cat?.count}</span>
          </button>
        );
      })}
    </div>
  );
};

export default FAQCategory;
